/** Normalize settings so contact_emails is always a 3-slot array (legacy contact_email supported). */
export function normalizeSettings(settings = {}) {
  const emails = Array.isArray(settings.contact_emails)
    ? [...settings.contact_emails]
    : settings.contact_email
      ? [settings.contact_email]
      : [];

  while (emails.length < 3) emails.push("");
  const contact_emails = emails.slice(0, 3);

  const { contact_email: _legacy, ...rest } = settings;
  return { ...rest, contact_emails };
}

export function getContactEmails(settings) {
  return normalizeSettings(settings).contact_emails.map((e) => e?.trim()).filter(Boolean);
}

/** Public URL for the footer BCS AGM report PDF (empty when not set). */
export function getAgmPdfUrl(settings) {
  return normalizeSettings(settings).agm_pdf_url?.trim() || "";
}

/** Public URL for the footer audited annual accounts PDF (empty when not set). */
export function getAnnualAccountsPdfUrl(settings) {
  return normalizeSettings(settings).annual_accounts_pdf_url?.trim() || "";
}
